module.exports = __webpack_public_path__ + "img/logo_black.56ccd3db.png";